import React, { ReactNode } from 'react';
import TopMenu from './TopMenu/TopMenu';
import InfoPanel from './InfoPanel';
import Footer from './Footer';

import classNames from 'classnames';
import styles from './assets/main.module.scss';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store/reducers';
import Loader from '../Loader';
import ConfirmNotificator from './ConfirmNotificator/ConfirmNotificator';
import { usePageTitle } from 'src/hooks/usePageTitle';

interface Props {
    children?: ReactNode;
}
const Main: React.FC<Props> = (props: Props) => {
    const inProgress = useSelector((state: StoreState) => state.app.inProgress);

    usePageTitle();

    return (
        <div className={classNames(styles.layout)}>
            <TopMenu />
            {inProgress ? <Loader /> : null}
            <InfoPanel />
            <ConfirmNotificator />
            <div className={classNames(styles.pageContent)}>{props.children}</div>
            <Footer />
        </div>
    );
};

export default Main;
